<script setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useMapGetter } from 'dashboard/composables/store';
import { useWgptAuditTrail } from 'dashboard/composables/wgpt/wgptAuditTrail';
import Button from 'next/button/Button.vue';
import DisconnectSallaDialog from './DisconnectSallaDialog.vue';
import InboxSettings from './InboxSettings.vue';
import OrdersSettings from './OrdersSettings.vue';
import AuditTrails from './SallaEditorAuditTrails.vue';

const props = defineProps({
  appId: {
    type: String,
    required: true,
  },
  hookId: {
    type: Number,
    required: true,
  },
  automationId: {
    type: Number,
    default: null,
  },
  config: {
    type: Object,
    default: () => ({}),
  },
});

const { t } = useI18n();
const uiFlags = useMapGetter('wgptIntegrations/getUIFlags');
const { isFeatureEnabled } = useWgptAuditTrail();

const disconnectSallaDialog = ref(false);

const openDisconnectPopup = () => {
  disconnectSallaDialog.value?.open({
    appId: props.appId,
    hookId: props.hookId,
  });
};
</script>

<template>
  <div class="p-6 flex flex-col gap-6">
    <div class="flex flex-col gap-2">
      <h3 class="text-base font-medium leading-6 text-n-slate-12">
        <span class="truncate">
          {{ t('WGPT_INTEGRATIONS.SALLA.EDITOR.SETTINGS.TITLE') }}
        </span>
      </h3>
      <p class="mb-0 text-sm text-n-slate-11">
        {{ t('WGPT_INTEGRATIONS.SALLA.EDITOR.SETTINGS.DESCRIPTION') }}
      </p>
    </div>

    <div class="flex">
      <Button
        size="sm"
        ruby
        :label="t('WGPT_INTEGRATIONS.SALLA.EDITOR.SETTINGS.DISCONNECT_BUTTON')"
        :is-loading="uiFlags.isDeletingSalla"
        :disabled="uiFlags.isDeletingSalla"
        @click.prevent="openDisconnectPopup"
      />
    </div>

    <div class="border-t border-n-weak" />

    <InboxSettings :config="config" />

    <div class="border-t border-n-weak" />

    <OrdersSettings :config="config" />

    <div class="border-t border-n-weak" />

    <AuditTrails v-if="isFeatureEnabled" :automation-id="automationId" />

    <DisconnectSallaDialog ref="disconnectSallaDialog" />
  </div>
</template>
